module.exports = __webpack_public_path__ + "static/media/HOLLY.00386cbe.JPG";